import React from 'react';

interface TechItem {
  name: string;
  category: string;
  color: string;
  badgeBg: string;
  icon: React.ReactNode;
}

export const techStackData: TechItem[] = [
  {
    name: 'Laravel',
    category: 'Backend Framework',
    color: '#FF2D20',
    badgeBg: 'rgba(255, 45, 32, 0.12)',
    icon: <img src="/assets/Laravel Icon.png" alt="Laravel" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  },
  {
    name: 'PHP',
    category: 'Server-Side Language',
    color: '#777BB4',
    badgeBg: 'rgba(119, 123, 180, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="6" width="20" height="12" rx="3" stroke="#777BB4" strokeWidth="2"/>
        <path d="M6 9V15M6 12H8.5C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9H6Z" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M14 9V15M14 12H16.5C17.3 12 18 11.3 18 10.5C18 9.7 17.3 9 16.5 9H14Z" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M11 9V15" stroke="#777BB4" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    name: 'Canva',
    category: 'Graphic Design',
    color: '#00C4CC',
    badgeBg: 'rgba(0, 196, 204, 0.15)',
    icon: <img src="/assets/Canva Icon.jpg" alt="Canva" style={{ width: '28px', height: '28px', objectFit: 'contain', borderRadius: '4px' }} />
  },
  {
    name: 'CapCut',
    category: 'Video Editing',
    color: '#FF0050',
    badgeBg: 'rgba(255, 0, 80, 0.15)',
    icon: <img src="/assets/CAPCUT ICON.png" alt="CapCut" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  },
  {
    name: 'MySQL',
    category: 'Relational Database',
    color: '#00618A',
    badgeBg: 'rgba(0, 97, 138, 0.15)',
    icon: <img src="/assets/SQL Icon.png" alt="MySQL" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  },
  {
    name: 'Supabase',
    category: 'BaaS & Database',
    color: '#3ECF8E',
    badgeBg: 'rgba(62, 207, 142, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="url(#supabase-grad)" stroke="#3ECF8E" strokeWidth="1.5" strokeLinejoin="round"/>
        <defs>
          <linearGradient id="supabase-grad" x1="3" y1="2" x2="21" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3ECF8E"/>
            <stop offset="1" stopColor="#1C744F"/>
          </linearGradient>
        </defs>
      </svg>
    )
  },
  {
    name: 'Cloudflare',
    category: 'Edge & Infrastructure',
    color: '#F38020',
    badgeBg: 'rgba(243, 128, 32, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5 19H6.5C4.01 19 2 16.99 2 14.5C2 12.24 3.66 10.37 5.86 10.06C6.44 7.15 8.99 5 12 5C15.42 5 18.25 7.64 18.48 11.02C20.48 11.27 22 12.96 22 15C22 17.21 20.21 19 18 19" stroke="#F38020" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    name: 'GitHub',
    category: 'Version Control',
    color: '#E6EDF3',
    badgeBg: 'rgba(255, 255, 255, 0.1)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017C2 16.443 4.87 20.198 8.84 21.52C9.34 21.61 9.52 21.3 9.52 21.04C9.52 20.81 9.51 20.2 9.51 19.39C6.73 19.99 6.14 18.05 6.14 18.05C5.69 16.89 5.04 16.58 5.04 16.58C4.13 15.96 5.11 15.97 5.11 15.97C6.12 16.04 6.65 17.01 6.65 17.01C7.55 18.55 9 18.11 9.56 17.86C9.65 17.21 9.91 16.77 10.2 16.52C7.98 16.27 5.64 15.41 5.64 11.58C5.64 10.49 6.03 9.59 6.67 8.89C6.57 8.64 6.23 7.62 6.77 6.25C6.77 6.25 7.61 5.98 9.52 7.27C10.32 7.05 11.17 6.94 12.02 6.94C12.87 6.94 13.72 7.05 14.52 7.27C16.43 5.98 17.27 6.25 17.27 6.25C17.81 7.62 17.47 8.64 17.37 8.89C18.01 9.59 18.4 10.49 18.4 11.58C18.4 15.42 16.05 16.27 13.82 16.52C14.19 16.84 14.52 17.47 14.52 18.43C14.52 19.8 14.51 20.91 14.51 21.04C14.51 21.3 14.69 21.62 15.2 21.52C19.17 20.19 22 16.44 22 12.017C22 6.484 17.52 2 12 2Z" fill="#E6EDF3"/>
      </svg>
    )
  },
  {
    name: 'TypeScript',
    category: 'Typed Language',
    color: '#3178C6',
    badgeBg: 'rgba(49, 120, 198, 0.15)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="3" fill="#3178C6"/>
        <path d="M7 9H13M10 9V17" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 15.5C14.5 16.3 15.3 16.8 16.3 16.8C17.3 16.8 18 16.2 18 15.4C18 14.5 17 14.1 16 13.7C14.8 13.2 14.1 12.6 14.1 11.4C14.1 10.3 15.1 9.5 16.3 9.5C17.2 9.5 17.9 9.9 18.4 10.6" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    name: 'HTML5',
    category: 'Web Markup',
    color: '#E34F26',
    badgeBg: 'rgba(227, 79, 38, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 3L6 20L12 21.5L18 20L19.5 3H4.5Z" stroke="#E34F26" strokeWidth="2" strokeLinejoin="round"/>
        <path d="M8 8H16L15.5 12H8.5L9 16L12 17L15 16L15.2 14" stroke="#E34F26" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    name: 'CSS3',
    category: 'Styling & Design',
    color: '#1572B6',
    badgeBg: 'rgba(21, 114, 182, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 3L6 20L12 21.5L18 20L19.5 3H4.5Z" stroke="#1572B6" strokeWidth="2" strokeLinejoin="round"/>
        <path d="M16 8H8.5L9 12H15.5L15 16L12 17L9 16L8.8 14" stroke="#1572B6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    name: 'Java',
    category: 'Object-Oriented Language',
    color: '#ED8B00',
    badgeBg: 'rgba(237, 139, 0, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 19C13 19 16 17.5 16 16.5C16 15.5 12 15 9 15C6 15 2 15.5 2 16.5C2 17.5 5 19 9 19Z" stroke="#ED8B00" strokeWidth="1.5"/>
        <path d="M10 12C12 10.5 13 9 12 7.5C11 6 8.5 5 10 3" stroke="#007396" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M13 13.5C15 12.5 16 11 15 9.5C14 8 11.5 7 13 5" stroke="#ED8B00" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    name: 'JavaScript',
    category: 'Core Web Language',
    color: '#F7DF1E',
    badgeBg: 'rgba(247, 223, 30, 0.15)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="18" height="18" rx="3" fill="#F7DF1E"/>
        <path d="M11 11V16.5C11 17.3 10.4 18 9.5 18C8.6 18 8 17.4 8 16.5" stroke="#111" strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 15.5C14.5 16.3 15.3 16.8 16.3 16.8C17.3 16.8 18 16.2 18 15.4C18 14.5 17 14.1 16 13.7C14.8 13.2 14.1 12.6 14.1 11.4C14.1 10.3 15.1 9.5 16.3 9.5C17.2 9.5 17.9 9.9 18.4 10.6" stroke="#111" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  },
  {
    name: 'React',
    category: 'UI Library',
    color: '#61DAFB',
    badgeBg: 'rgba(97, 218, 251, 0.12)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="2" fill="#61DAFB"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(0 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(60 12 12)"/>
        <ellipse cx="12" cy="12" rx="9" ry="3.5" stroke="#61DAFB" strokeWidth="1.5" transform="rotate(120 12 12)"/>
      </svg>
    )
  },
  {
    name: 'Claude Code',
    category: 'AI Coding Assistant',
    color: '#D97706',
    badgeBg: 'rgba(217, 119, 6, 0.15)',
    icon: <img src="/assets/claude Icon.png" alt="Claude Code" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  },
  {
    name: 'Google AntiGravity',
    category: 'AI Agentic IDE',
    color: '#00F2FE',
    badgeBg: 'rgba(0, 242, 254, 0.15)',
    icon: <img src="/assets/ANTI GRAVITY ICON.png" alt="Google AntiGravity" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  },
  {
    name: 'OpenAI Codex',
    category: 'AI Code Engine',
    color: '#10A37F',
    badgeBg: 'rgba(16, 163, 127, 0.15)',
    icon: <img src="/assets/codex-icon.webp" alt="OpenAI Codex" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
  }
];

export const TechStackCarousel: React.FC = () => {
  // Duplicate array for seamless infinite marquee scroll
  const carouselItems = [...techStackData, ...techStackData];

  return (
    <div className="tech-carousel-wrapper">
      <div className="tech-carousel-header">
        <h3 className="tech-carousel-title" style={{ color: 'var(--card-heading)' }}>
          Programming Languages & <span>Core Tech Stack</span>
        </h3>
        <p className="tech-carousel-subtitle">
          Continuous learning across modern languages, server frameworks, design tools, and databases.
        </p>
      </div>

      <div className="tech-carousel-container">
        {/* Left and Right Fade Gradients */}
        <div className="tech-carousel-fade fade-left"></div>
        <div className="tech-carousel-fade fade-right"></div>

        {/* Marquee Track */}
        <div className="tech-carousel-track">
          {carouselItems.map((tech, idx) => (
            <div
              key={`${tech.name}-${idx}`}
              className="tech-card"
              style={
                {
                  '--accent-color': tech.color,
                  '--badge-bg': tech.badgeBg
                } as React.CSSProperties
              }
            >
              <div className="tech-card-icon">{tech.icon}</div>
              <div className="tech-card-info">
                <span className="tech-card-name">{tech.name}</span>
                <span className="tech-card-category">{tech.category}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
